import FormGenerator from './FormGenerator';

window['formGenerator'] = new FormGenerator();
